import axios from './configAxiosOrganizations';

export const confirmOrganization = async (org_id, requestData) => {
	return await axios.put(`/${org_id}/confirm/`, requestData);
};
